<template>
  <div>
    <h2 class="header-PARLAY" v-show="currentBetSlipState<1 || betTypeStakes.A">
      {{ $t('BetSlip.tab.title.PARLAY') }}
    </h2>
    <div v-if="allowedBetTypesPRL.length" >
      <div v-for="bt in allowedBetTypesPRL" v-show="currentBetSlipState<1 || betTypeStakes[bt.IDFOBetType]" >
        <bet-type-parlay
          :bt="bt"
          :stake="betTypeStakes[bt.IDFOBetType]"
          :parlayTeamsNo="parlayTeamsNo"
          :allowedBetTypesAndReturns="allowedBetTypesAndReturns"
          :gettingABTnR="gettingABTnR"
          :currentBetSlipState="currentBetSlipState"
        ></bet-type-parlay>
      </div>
    </div>
    <div class="msg info all_corners NoParlayAvailable" v-if="currentBetSlipState==0 && betsNo>1 && !allowedBetTypesPRL.length && !interRelatedLen">
      <icon name="icon-information" colorName="blue"></icon>
        {{ $t('BetSlip.tab.PARLAY.info.notAvailable') }}
    </div>
    <div class="msg info all_corners" v-if="currentBetSlipState==0 && betsNo==1">
      <icon name="icon-information" colorName="blue"></icon>
        {{ $t('BetSlip.tab.PARLAY.info.minSelectionsNo') }}
    </div>
    <div class="msg info interRelated all_corners" v-if="currentBetSlipState==0 && betsNo>1 && interRelatedLen">
      <icon name="icon-information" colorName="blue"></icon>
      {{ $t('BetSlip.tab.PARLAY.info.interRelated') }}
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import priceFormat from '@/library/priceFormat'
  import stakeAndReturn from './stakeNreturn.vue'
  import Icon from '@/components/common/Icon'
  import betTypeParlay from './betTypeParlay'

  export default {
    name: 'StraightsTab',

    props: ['allowedBetTypesAndReturns', 'currentBetSlipState', 'betsNo', 'allowedBetTypesPRL', 'gettingABTnR', 'betTypeStakes', 'betTypeStakeSPARLAY', 'winnings'],

    data () {
      return {
      }
    },

    components: {
      stakeAndReturn,
      Icon,
      betTypeParlay
    },

    computed: {
      interRelated () {
        return store.getters['sbBetslipState/interRelated']
      },
      interRelatedLen () {
        return Object.keys(this.interRelated).length
      }
      /*
       selectionsForBetType () {
       return store.getters['sbBetslipState/getSelectionsForBetType']
       }
       */
    },

    methods: {
      parlayTeamsNo (betType) {
        // var str = this.allowedBetTypesAndReturns.PotentialReturns.PerBetType[betType].CalculatedUnits
        // return str.split(';')[0].split(')')[0].split('(')[1].split(',').length
        var selections = store.getters['sbBetslipState/betslipSelections']
        return (selections && selections.length) || 0
      },
      formatOdds (betType) {
        var odds = betType.PotentialReturn - betType.UnitCount + 1
        var formatted = priceFormat.formatOdds(odds, -1)
        return formatted
      },
      initPlaceBet (id) {
        this.$emit('initPlaceBet', id)
      },
      placeBet (id) {
        this.$emit('placeBet', id)
      },
      cancelBet (id) {
        this.$emit('cancelBet', id)
      },
      updateStakePRL (win) {
//        console.log('updateStakePRL: ' + win)
        var t = this.allowedBetTypesPRL && this.allowedBetTypesPRL[0] && this.allowedBetTypesPRL[0].IDFOBetType
//        console.log(t)
        var stake = win
        stake = win / (this.allowedBetTypesAndReturns.PotentialReturns.PerBetType[t].PotentialReturn - 1)
        stake = stake.toFixed(2)
//        console.log('stake: ' + stake)
        this.betTypeStakes.PARLAY = stake
      }
    },

    created () {
//      console.log('Created REGULAR')
//      store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns')
    }
  }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/ParlayTab.vue